(() => {
  const initializedSections = new WeakSet();
  const TWO_BUY_TEXT = '2buy';
  let filterObserverInitialized = false;

  const hideTwoBuyFilterTabs = (scope = document) => {
    const removeTargets = new Set();
    const tabSelectors = ['.mobile-filter-tab', '.mobile-filter-modal__tab'];

    tabSelectors.forEach((selector) => {
      scope.querySelectorAll(selector).forEach((tab) => {
        const label = (tab.textContent || '').trim().toLowerCase();
        if (!label.includes(TWO_BUY_TEXT)) return;

        const target = tab.getAttribute('data-filter-target');
        if (target) removeTargets.add(target);
        tab.remove();
      });
    });

    removeTargets.forEach((target) => {
      scope.querySelectorAll(`[data-filter-panel="${target}"]`).forEach((panel) => panel.remove());
    });
  };

  const initSection = (sectionElement) => {
    if (!sectionElement || initializedSections.has(sectionElement)) return;

    const root = sectionElement.closest('.shopify-section') || document;
    const openButton = sectionElement.querySelector('[data-campaign-open]');
    const modal = root.querySelector('[data-campaign-modal]');
    if (!openButton || !modal) return;

    const dialog = modal.querySelector('.collection-campaign-modal__dialog');
    const closeButtons = modal.querySelectorAll('[data-campaign-close]');
    let scrollY = 0;
    const resolveModalTopOffset = () => {
      const headerSection = document.querySelector('.section-header');
      if (!headerSection) return 0;

      return Math.max(0, Math.round(headerSection.getBoundingClientRect().bottom));
    };

    const closeModal = () => {
      modal.setAttribute('hidden', 'hidden');
      modal.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      modal.style.removeProperty('--collection-campaign-modal-offset-top');
      document.body.classList.remove('collection-campaign-modal-open');
      document.body.style.top = '';
      window.scrollTo(0, scrollY);
      openButton.focus();
    };

    const openModal = () => {
      scrollY = window.scrollY || window.pageYOffset;
      modal.style.setProperty('--collection-campaign-modal-offset-top', `${resolveModalTopOffset()}px`);
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.style.top = `-${scrollY}px`;
      document.body.classList.add('collection-campaign-modal-open');
      if (dialog) dialog.focus();
    };

    openButton.addEventListener('click', openModal);
    closeButtons.forEach((button) => button.addEventListener('click', closeModal));

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
    });

    hideTwoBuyFilterTabs(document);
    requestAnimationFrame(() => hideTwoBuyFilterTabs(document));
    setTimeout(() => hideTwoBuyFilterTabs(document), 200);
    if (!filterObserverInitialized) {
      const observer = new MutationObserver(() => {
        hideTwoBuyFilterTabs(document);
      });
      observer.observe(document.body, { childList: true, subtree: true });
      filterObserverInitialized = true;
    }

    initializedSections.add(sectionElement);
  };

  const initAll = (container = document) => {
    container.querySelectorAll('[data-campaign-header-section]').forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
